import React, { useRef, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FullPageLoader } from "../FullPageLoader";
import CustomAlertDialog from "../components/Dialog";

export const LoadingScreen = () => {
  return <FullPageLoader />;
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { loading, isAuthenticated, role } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const dialogShownRef = useRef(false);

  // Intercept the redirect — set flag during render so the dialog
  // shows before any navigation happens.
  if (!loading && !isAuthenticated && !dialogShownRef.current && !dialogOpen) {
    dialogShownRef.current = true;
    setDialogOpen(true);
  }

  if (loading) {
    return <LoadingScreen />;
  }

  if (dialogOpen) {
    return (
      <CustomAlertDialog
        open
        title="Session Expired"
        message="Your session has timed out. Please sign in again to continue."
        iconType="warning"
        buttonText="Sign In"
        onClose={() => {
          setDialogOpen(false);
          navigate("/login", { replace: true, state: { from: location } });
        }}
      />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
